import React, { useState, useEffect, useContext } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import AuthUser from "../../AuthUser";
import ListLoader from "../Loaders/ListLoader";
import CopyToClipboard from 'react-copy-to-clipboard';
import { AppContext } from '../../context/AppContext';

function KYCList(){
    let navigate = useNavigate();
    const location = useLocation();
    const{headers1,headers2,logout}=AuthUser();
    const {type} = useParams();
    const [list, setList] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);
    const [SearchType, setSearchType] = useState('Any');
    const [SearchVal, setSearchVal] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1); // Total number of pages
    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [prevPageUrl, setPrevPageUrl] = useState(null);
    const pageRangeDisplayed = 2; 

    useEffect(()=>{
        const query = new URLSearchParams(location.search);
        const page = query.get('page') ? parseInt(query.get('page'), 10) : 1;
        const search = query.get('search') || '';
        setCurrentPage(page);
        setSearchVal(search);
        GetKYCList(page,type,search);
    },[location.search]);

    const GetKYCList=(page=1,type,val)=>{
        setSubloading(true);
        axios({
            method: 'post',
            url: Global.baseUrl+'FetchKYCList',
            headers:headers1,
            data: {
                SearchType:SearchType,
                SearchVal:SearchVal,
                page:page
            }
            })
            .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value.data;
                setList(data);
                setCurrentPage(response.data.value.current_page);
                setLastPage(response.data.value.last_page);
                setNextPageUrl(response.data.value.next_page_url); // URL for next page
                setPrevPageUrl(response.data.value.prev_page_url); // URL for previous page
            }
            else
            {
                setList();
            }
            setSubloading(false);
            setLoading(false);
            })
            .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            setSubloading(false);
            setLoading(false);
            // console.log(error);
            });
    }

    const handleStatus=(index)=>{
        setSubloading(true);
        const newList = [...list];
        let newValue="";
        if(newList[index]['status']=='Y'){
            newValue='N';
        }else{
            newValue='Y';
        }
        newList[index]['status'] = newValue;
        setList(newList);

        axios({
            method: 'post',
            url: Global.baseUrl+'UpdateCustomerKYCStatus',
            headers:headers1,
            data: {
                id:newList[index]['id'],
                value:newValue
            }
            })
            .then(function (response) {
            if(response.data.status == 200)
            {
                setSubloading(false);
                toast.success(response.data.message);
            }
            else
            {
                setSubloading(false);
                toast.error(response.data.message);
            }
            })
            .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            setSubloading(false);
            // console.log(error);
            });
    }

    const getStatusType = (status) => {
        switch (status) {
            case 'Y':
            return <span className="badge bg-success">Approved</span>;
            case 'N':
            return <span className="badge bg-danger">Not Approve</span>;
        }
    };

    // Update the URL and fetch the data for the selected page
    const handlePageChange = (pageNumber) => {
        const query = new URLSearchParams(location.search);
        query.set('page', pageNumber);
        navigate(`?${query.toString()}`);
    };

    const handleSearchChange = (event) => {
        setSearchVal(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const query = new URLSearchParams(location.search);
        query.set('search', SearchVal);
        query.set('page', 1); // Reset to page 1 on a new search
        navigate(`?${query.toString()}`);
    };

    // Handle Previous button click
    const handlePreviousPage = () => {
        if (prevPageUrl) {
        handlePageChange(currentPage - 1);
        }
    };

    // Handle Next button click
    const handleNextPage = () => {
        if (nextPageUrl) {
        handlePageChange(currentPage + 1);
        }
    };

    // Create pagination items for each page, showing a limited number of page numbers with ellipses
    const renderPageNumbers = () => {
        const pages = [];

        // Always show the first page
        if (currentPage > pageRangeDisplayed + 1) {
            pages.push(
                <li key={1} className="page-item">
                <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
                </li>
            );
            pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }

        // Show the range of pages around the current page
        for (let i = Math.max(1, currentPage - pageRangeDisplayed); i <= Math.min(lastPage, currentPage + pageRangeDisplayed); i++) {
            pages.push(
                <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(i)}>
                        {i}
                    </button>
                </li>
            );
        }

        // Always show the last page
        if (currentPage < lastPage - pageRangeDisplayed) {
            pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
            pages.push(
                <li key={lastPage} className="page-item">
                <button className="page-link" onClick={() => handlePageChange(lastPage)}>{lastPage}</button>
                </li>
            );
        }

        return pages;
    };

      return(
            <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
            {Loading==true?<MainLoader/>:
                <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <Link to={`/Admin-Dash`}>
                                        <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">KYC</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" type="button" onClick={()=>navigate(-1)}>
                                    <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">All KYC</h2>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className="table-settings shipment_list" id="">
                            <div className="row align-items-end g-2" >
                                <div className="col col-md ">
                                <form onSubmit={handleSearchSubmit}>
                                        <div className="input-group ">
                                            <select className="form-select" onChange={(e)=>setSearchType(e.target.value)}>
                                            <option value='Any'>Any</option>
                                            <option value='doc_type'>Document Type</option>
                                            <option value='doc_number'>Document Number</option>
                                            </select>
                                            <input type="text" className="form-control w-50" placeholder="Search" onChange={handleSearchChange} />
                                            <button type="submit" className="input-group-text">
                                                <i className="bx bx-search"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <section className="data_table">
                    <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="border-gray-200">Customer</th>
                                    <th className="border-gray-200">Document Type</th>
                                    <th className="border-gray-200">Document Number</th>
                                    <th className="border-gray-200">Image</th>
                                    <th className="border-gray-200">Verification</th>
                                    <th className="border-gray-200">Status</th>
                                </tr>
                            </thead>
                            {Subloading==true && <ListLoader/>}
                            {list!=undefined && Subloading==false ?
                            <tbody>
                                {list.map((cust,index)=>{
                                    return(
                                    <tr key={index}>
                                       
                                        <td><span className="fa-normal text-capitalize">{cust.customer_name}</span></td>
                                        <td><span className="fw-normal text-capitalize">{cust.doc_type}</span></td>
                                        <td><span className="fw-normal text-capitalize">{cust.doc_number}</span></td>
                                        <td>
                                            <img src={`${Global.kyc}${cust.doc_image}`}
                                                className="img-fluid rounded mt-2" style={{ width: 120, height: 120, objectFit: 'cover' }} />
                                        </td>
                                        <td><span className="fw-normal text-capitalize">{ getStatusType(cust.status) }</span></td>
                                        <td>
                                            <div className="form-check form-switch  mb-2">
                                            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={cust.status=='Y'?true:false} onChange={()=>handleStatus(index)} />
                                            </div>
                                        </td>
                                    </tr>
                                )})}                 
                            </tbody>
                            :
                            <tbody><tr><td colSpan={6}>Record Not Found</td></tr></tbody>
                            }
                        </table>
                        
                        
                    </div>
                </section>
                <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                    <nav aria-label="Page navigation example">
                        <ul className="pagination mb-0">
                        {/* Previous Button */}
                        <li className={`page-item ${!prevPageUrl ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={handlePreviousPage} disabled={!prevPageUrl}>
                            Previous
                            </button>
                        </li>
    
                        {/* Page Numbers */}
                        {renderPageNumbers()}
    
                        {/* Next Button */}
                        <li className={`page-item ${!nextPageUrl ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={handleNextPage} disabled={!nextPageUrl}>
                            Next
                            </button>
                        </li>
                        </ul>
                    </nav>
                    {/* <div className="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div> */}
                </div>
                </>
            }
                <Footer/>
            </main>
            </>
    
        );

}
export default KYCList;